function print(elementId, title) {
  // Get HTML to print from element
  const prtHtml = document.getElementById(elementId).innerHTML;

  // Get all stylesheets HTML
  let stylesHtml = "";
  for (const node of [
    ...document.querySelectorAll('link[rel="stylesheet"], style'),
  ]) {
    stylesHtml += node.outerHTML;
  }

  // Open the print window
  let winPrint = window.open(
    "",
    "",
    "left=0,top=0,width=2480,height=3508,toolbar=0,scrollbars=0,status=0"
  );

  winPrint.document.write(`<!DOCTYPE html>
    <html>
      <head>
        <title>${title}_${new Date().toISOString().slice(0, 10)}</title>
        ${stylesHtml}
      </head>
      <body>
        ${prtHtml}
      </body>
    </html>`);

  winPrint.document.close();
  winPrint.focus();
  winPrint.print();
}

function printHtml(html) {
  let winPrint = window.open(
    "",
    "",
    "left=0,top=0,width=2480,height=3508,toolbar=0,scrollbars=0,status=0"
  );

  winPrint.document.write(html);
  winPrint.document.close();
  winPrint.focus();
  winPrint.print();
}

export { print, printHtml };
